import { render, staticRenderFns } from "./property-schedule.vue?vue&type=template&id=233c07c3&"
import script from "./property-schedule.vue?vue&type=script&lang=js&"
export * from "./property-schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports